"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCanonicalLinkUrl = void 0;
const getCanonicalLinkUrl = (hostname, pathname) => {
  const host = hostname.replace(/(https?:)?(\/\/)?(.*)/, ($, $1, $2, $3) => `${$1 ?? 'https:'}${$2 ?? '//'}${$3}`);
  const path = pathname.replaceAll(/^\/+|\/+$/g, '');
  return `${host}/${path}`;
};
exports.getCanonicalLinkUrl = getCanonicalLinkUrl;
